export enum TextType {
    percent = 'percent',
    currency = 'currency',
}